import { jsx as _jsx } from "react/jsx-runtime";
import { Chip } from '@mui/material';
import { appStrings } from '../assets/appStrings';
var STRINGS = appStrings.modules.emulationChip;
export var EmulationChip = function () { return (_jsx(Chip, { variant: "tag", size: "sm", label: STRINGS.label, sx: chipSx })); };
var chipSx = function (_a) {
    var backrs = _a.backrs;
    return ({
        width: 'fit-content',
        flexShrink: 0,
        border: "1px solid ".concat(backrs.colors['Colors/Foreground/fg-success-secondary']),
        backgroundColor: backrs.colors['Colors/Background/bg-success-primary'],
        '& .MuiChip-label': {
            color: backrs.colors['Colors/Text/text-success-primary'],
        },
    });
};
